import { useEffect, useState } from "react";
import { useParams } from 'react-router';
import query from "../../../../server/constants.api";
import useFetch from "../../../../server/useFetch";
import { useTranslation } from "react-i18next";
import { Row, Col, Flex } from 'antd';
import { Widget } from "../../Atomics/Widget";

export const ProductionEnergy = ({ dataToFilter, electricityProductionPowerRef, hasProductionEnergy, isProductionEnergyLoading }) => {
  const { t } = useTranslation();
  const { id } = useParams();

  const [dataProductionEnergy, setDataProductionEnergy] = useState(null);

  const {
    data: productionEnergyData,
    isLoading: productionEnergyIsLoading,
    refetch: refetchProductionEnergyData
  } = useFetch(query.path.detailRegistryProduction, 'getDetailRegistryProduction',
    { id: id, filters: JSON.stringify(dataToFilter) });

    useEffect(() => {
      isProductionEnergyLoading(productionEnergyIsLoading)
    }, [productionEnergyIsLoading]);
    
  useEffect(() => {
    if (productionEnergyData?.data) {
      setDataProductionEnergy(productionEnergyData?.data)
      hasProductionEnergy(productionEnergyData?.data)
    }
  }, [productionEnergyData?.data]);

  useEffect(() => {
    hasProductionEnergy(null)
    refetchProductionEnergyData();
  }, [dataToFilter]);

  return (

    dataProductionEnergy?.production?.series?.length ?
      <Row id="Production" gutter={[16, 16]}>
        < Col span={6} >
          <Flex gap={16} vertical='true'>
            <Widget data={{
              height: '150px',
              background: 'white',
              icon: 'Bolt',
              title: t('energyProduced'),
              charts: [
                {
                  chartType: 'bigNumberChart',
                  chartId: 'bigNumberChartOne',
                  data: dataProductionEnergy?.producedEnergy
                }
              ]
            }} />
            <Widget data={{
              height: '150px',
              background: 'white',
              icon: 'Bolt',
              title: '% ' + t('selfConsumption'),
              charts: [
                {
                  chartType: 'bigNumberChart',
                  data: dataProductionEnergy?.percentAutoconsume
                }
              ]
            }} />
            <Widget data={{
              height: '150px',
              background: 'white',
              icon: 'Emissions',
              title: t('emissionsAvoided'),
              charts: [
                {
                  chartType: 'bigNumberChart',
                  data: dataProductionEnergy?.avoidedEmissions
                }
              ]
            }} />
          </Flex>
        </Col >
        <Col span={18}>
          <div ref={electricityProductionPowerRef}>
            <Widget data={{
              height: '482px',
              background: 'white',
              title: t('production'),
              icon: 'Bolt',
              charts: [
                {
                  chartType: 'columnsChartApex',
                  chartId: 'barChartWithMultiXAxisOne',
                  data: dataProductionEnergy?.production
                }
              ]
            }} /></div>
        </Col>

      </Row >

      : null

  )
}